module.exports = __webpack_public_path__ + "img/motorbikeOverview2Outline.13ffaf1b.svg";